{
	"title": "Du må logge inn",
	"description": "For å se denne siden, er det nødvendig å være logget inn. Vennligst logg inn. Etterpå vil du bli omdirigert til den forespurte siden.",
	"primaryButtonTitle": "Åpne pålogging"
}
